import { Component, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { FormBuilder } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ReactiveFormsModule } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { NgxAimAdminPrimengModule } from '../../ngx-aim-admin.primeng.module';
import { ControlsOf } from '../../../../types';
import { SetTaxAuthorityDto, TaxAuthority } from '../../../../models';
import { HttpErrorService } from '../../../../services';
import { NgxAimAdminTaxAuthorityService } from '../ngx-aim-admin-tax-authority.service';

@Component({
  selector: 'ngx-aim-admin-edit-tax-authority',
  standalone: true,
  imports: [ReactiveFormsModule, NgxAimAdminPrimengModule],
  templateUrl: './ngx-aim-admin-edit-tax-authority.component.html',
  styleUrls: ['./ngx-aim-admin-edit-tax-authority.component.scss', '../../admin.scss'],
  providers: [DatePipe],
})
export class NgxAimAdminEditTaxAuthorityComponent implements OnInit {
  isLoading = false;
  isSaving = false;

  form = this.fb.group<ControlsOf<SetTaxAuthorityDto>>({
    Id: this.fb.control<number | null>(null),
    isDefault: this.fb.control<boolean | null>(false),
    Desc: this.fb.control<string | null>(''),
    ShortDesc: this.fb.control<string | null>(''),
    City: this.fb.control<string | null>(''),
    County: this.fb.control<string | null>(''),
    ZipCode: this.fb.control<string | null>(''),
    GeoCode: this.fb.control<string | null>(''),
    TaxRate1: this.fb.control<number | null>(0),
    TaxRate2: this.fb.control<number | null>(0),
  });

  metaForm = this.fb.group({
    createDate: [{ value: '', disabled: true }],
    updateDate: [{ value: '', disabled: true }],
  });

  constructor(
    private entityService: NgxAimAdminTaxAuthorityService,
    private fb: FormBuilder,
    private config: DynamicDialogConfig,
    private dialogRef: DynamicDialogRef,
    private messageService: MessageService,
    private httpErrorService: HttpErrorService,
    private datePipe: DatePipe,
  ) {}

  ngOnInit() {
    this.form.disable();
    if (this.config.data) {
      this.getEntity(this.config.data);
    }
  }

  getEntity(entityId: number) {
    this.isLoading = true;
    this.entityService.findOne(entityId).subscribe({
      next: (entity) => this.setFormData(entity),
      error: (err) => this.onError(err, 'Could not retrieve tax authority')
    });
  }

  setFormData(entity: TaxAuthority) {
    this.isLoading = false;
    this.form.patchValue(entity);
    this.metaForm.patchValue({
      createDate: this.datePipe.transform(new Date(entity.createDate), 'short'),
      updateDate: this.datePipe.transform(new Date(entity.updateDate), 'short'),
    });
  }

  onSetDefault() {
    this.isSaving = true;
    this.entityService.setDefault(this.form.getRawValue()).subscribe({
      next: (entity) => this.onSuccess(entity),
      error: (err) => this.onError(err, 'Could not save tax authority')
    });
  }

  onCancel() {
    this.dialogRef.close();
  }

  onError(err: any, message: string) {
    this.isSaving = false;
    this.isLoading = false;
    this.httpErrorService.onHttpError(err, message);
  }

  onSuccess(entity: TaxAuthority) {
    this.setFormData(entity);
    this.isSaving = false;
    this.messageService.add({
      severity: 'success',
      summary: 'Tax authority saved',
      key: 'app-toast'
    });
  }
}
